//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Created
     */
    createNoteAndTask(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateNoteAndTaskModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/NoteAndTask";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNoteAndTask(_response);
        });
    }

    protected processCreateNoteAndTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateBadPhoneNumber(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdateBadPhoneNumberModel | undefined): Promise<UpdateBadPhoneNumberResponse> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/BadPhoneNumber";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBadPhoneNumber(_response);
        });
    }

    protected processUpdateBadPhoneNumber(response: Response): Promise<UpdateBadPhoneNumberResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateBadPhoneNumberResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateBadPhoneNumberResponse>(null as any);
    }

    /**
     * @param callListId (optional) 
     * @param skipAgentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRandomAgentInfo(v: string, callListId?: number | undefined, skipAgentId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentInfoResponseModel> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/RandomAgentInfo?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (callListId === null)
            throw new Error("The parameter 'callListId' cannot be null.");
        else if (callListId !== undefined)
            url_ += "CallListId=" + encodeURIComponent("" + callListId) + "&";
        if (skipAgentId === null)
            throw new Error("The parameter 'skipAgentId' cannot be null.");
        else if (skipAgentId !== undefined)
            url_ += "SkipAgentId=" + encodeURIComponent("" + skipAgentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRandomAgentInfo(_response);
        });
    }

    protected processGetRandomAgentInfo(response: Response): Promise<AgentInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentInfoResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentInfoResponseModel>(null as any);
    }

    /**
     * @param callListId (optional) 
     * @param agentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentInfoByAgentId(v: string, callListId?: number | undefined, agentId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentInfoResponseModel> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/AgentInfoByAgentId?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (callListId === null)
            throw new Error("The parameter 'callListId' cannot be null.");
        else if (callListId !== undefined)
            url_ += "callListId=" + encodeURIComponent("" + callListId) + "&";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentInfoByAgentId(_response);
        });
    }

    protected processGetAgentInfoByAgentId(response: Response): Promise<AgentInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentInfoResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentInfoResponseModel>(null as any);
    }

    /**
     * @param callListId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getExistingCallList(v: string, callListId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ExistingCallListResponse> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/ExistingCallList?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (callListId === null)
            throw new Error("The parameter 'callListId' cannot be null.");
        else if (callListId !== undefined)
            url_ += "CallListId=" + encodeURIComponent("" + callListId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter === null)
            throw new Error("The parameter 'fullTextFilter' cannot be null.");
        else if (fullTextFilter !== undefined)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExistingCallList(_response);
        });
    }

    protected processGetExistingCallList(response: Response): Promise<ExistingCallListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingCallListResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistingCallListResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketerEvents(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/MarketerEvents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketerEvents(_response);
        });
    }

    protected processGetMarketerEvents(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketers(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/Marketers";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketers(_response);
        });
    }

    protected processGetMarketers(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param zipCode (optional) 
     * @param miles (optional) 
     * @param withInStateBoundary (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getZipcodesByRange(v: string, zipCode?: string | undefined, miles?: number | undefined, withInStateBoundary?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/Zipcodes?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (zipCode === null)
            throw new Error("The parameter 'zipCode' cannot be null.");
        else if (zipCode !== undefined)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (miles === null)
            throw new Error("The parameter 'miles' cannot be null.");
        else if (miles !== undefined)
            url_ += "Miles=" + encodeURIComponent("" + miles) + "&";
        if (withInStateBoundary === null)
            throw new Error("The parameter 'withInStateBoundary' cannot be null.");
        else if (withInStateBoundary !== undefined)
            url_ += "WithInStateBoundary=" + encodeURIComponent("" + withInStateBoundary) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetZipcodesByRange(_response);
        });
    }

    protected processGetZipcodesByRange(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param marketerId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCompanyAndProductSubCategory(v: string, marketerId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CompanyAndProductSubCategoryResponse> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/CompanyAndProductSubCategory?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (marketerId === null)
            throw new Error("The parameter 'marketerId' cannot be null.");
        else if (marketerId !== undefined)
            url_ += "marketerId=" + encodeURIComponent("" + marketerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompanyAndProductSubCategory(_response);
        });
    }

    protected processGetCompanyAndProductSubCategory(response: Response): Promise<CompanyAndProductSubCategoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyAndProductSubCategoryResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return No Content
     */
    removeCallList(callListId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/CallList/{callListId}";
        if (callListId === undefined || callListId === null)
            throw new Error("The parameter 'callListId' must be defined.");
        url_ = url_.replace("{callListId}", encodeURIComponent("" + callListId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveCallList(_response);
        });
    }

    protected processRemoveCallList(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param callListName (optional) 
     * @param callListFor (optional) 
     * @param marketerEventId (optional) 
     * @param callListAgentIdentifiers (optional) 
     * @param prospectiveFlag (optional) 
     * @param npnFlag (optional) 
     * @param file (optional) 
     * @param isUploadFile (optional) 
     * @return Created
     */
    importCallList(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, callListName?: string | undefined, callListFor?: number | undefined, marketerEventId?: number | undefined, callListAgentIdentifiers?: number[] | undefined, prospectiveFlag?: boolean | undefined, npnFlag?: boolean | undefined, file?: FileParameter | undefined, isUploadFile?: boolean | undefined): Promise<CreateCustomCallListReponseModel> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/ImportCallList";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (callListName === null || callListName === undefined)
            throw new Error("The parameter 'callListName' cannot be null.");
        else
            content_.append("CallListName", callListName.toString());
        if (callListFor === null || callListFor === undefined)
            throw new Error("The parameter 'callListFor' cannot be null.");
        else
            content_.append("CallListFor", callListFor.toString());
        if (marketerEventId === null || marketerEventId === undefined)
            throw new Error("The parameter 'marketerEventId' cannot be null.");
        else
            content_.append("MarketerEventId", marketerEventId.toString());
        if (callListAgentIdentifiers === null || callListAgentIdentifiers === undefined)
            throw new Error("The parameter 'callListAgentIdentifiers' cannot be null.");
        else
            callListAgentIdentifiers.forEach(item_ => content_.append("CallListAgentIdentifiers", item_.toString()));
        if (prospectiveFlag === null || prospectiveFlag === undefined)
            throw new Error("The parameter 'prospectiveFlag' cannot be null.");
        else
            content_.append("ProspectiveFlag", prospectiveFlag.toString());
        if (npnFlag === null || npnFlag === undefined)
            throw new Error("The parameter 'npnFlag' cannot be null.");
        else
            content_.append("NpnFlag", npnFlag.toString());
        if (file !== null && file !== undefined)
        content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (isUploadFile === null || isUploadFile === undefined)
            throw new Error("The parameter 'isUploadFile' cannot be null.");
        else
            content_.append("IsUploadFile", isUploadFile.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportCallList(_response);
        });
    }

    protected processImportCallList(response: Response): Promise<CreateCustomCallListReponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomCallListReponseModel;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCustomCallListReponseModel>(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLeadSource(v: string, isActive?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/LeadSource?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadSource(_response);
        });
    }

    protected processGetLeadSource(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    markAgentAsCalled(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MarkAgentAsCalledModel | undefined): Promise<ExistingCallListResponseModel> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/MarkAgentAsCalled";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAgentAsCalled(_response);
        });
    }

    protected processMarkAgentAsCalled(response: Response): Promise<ExistingCallListResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistingCallListResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistingCallListResponseModel>(null as any);
    }

    /**
     * @param callListId (optional) 
     * @param recentCount (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRecentCalledAgents(v: string, callListId?: number | undefined, recentCount?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<GetRecentCalledAgentsResponse> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/RecentCalledAgents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (callListId === null)
            throw new Error("The parameter 'callListId' cannot be null.");
        else if (callListId !== undefined)
            url_ += "callListId=" + encodeURIComponent("" + callListId) + "&";
        if (recentCount === null)
            throw new Error("The parameter 'recentCount' cannot be null.");
        else if (recentCount !== undefined)
            url_ += "recentCount=" + encodeURIComponent("" + recentCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecentCalledAgents(_response);
        });
    }

    protected processGetRecentCalledAgents(response: Response): Promise<GetRecentCalledAgentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRecentCalledAgentsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRecentCalledAgentsResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllStatesAndCountys(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<GetAllStatesAndCountysResponse> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/StatesAndCountys";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllStatesAndCountys(_response);
        });
    }

    protected processGetAllStatesAndCountys(response: Response): Promise<GetAllStatesAndCountysResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAllStatesAndCountysResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllStatesAndCountysResponse>(null as any);
    }

    /**
     * @param count (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Created
     */
    generateProspectiveCallList(v: string, count?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: GenerateProspectiveCallListModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/ProspectiveCallList?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateProspectiveCallList(_response);
        });
    }

    protected processGenerateProspectiveCallList(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getProspectivePreviewResults(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: GetProspectivePreviewRequestModel | undefined): Promise<GetProspectivePreviewResponse> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/ProspectivePreviewResults";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProspectivePreviewResults(_response);
        });
    }

    protected processGetProspectivePreviewResults(response: Response): Promise<GetProspectivePreviewResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProspectivePreviewResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetProspectivePreviewResponse>(null as any);
    }

    /**
     * @param count (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Created
     */
    generateActiveCallList(v: string, count?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: GenerateActiveCallListModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/ActiveCallList?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateActiveCallList(_response);
        });
    }

    protected processGenerateActiveCallList(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getActivePreviewResults(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: GetActivePreviewRequestModel | undefined): Promise<GetActivePreviewResponse> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/ActivePreviewResults";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivePreviewResults(_response);
        });
    }

    protected processGetActivePreviewResults(response: Response): Promise<GetActivePreviewResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivePreviewResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetActivePreviewResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    downloadIContactListResults(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ContactListRequestModel | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/DownloadIContactList";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadIContactListResults(_response);
        });
    }

    protected processDownloadIContactListResults(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param phoneNumber (optional) 
     * @param agentId (optional) 
     * @param sourceName (optional) 
     * @return Success
     */
    callLog(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, phoneNumber?: string | undefined, agentId?: number | undefined, sourceName?: string | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/dialer/v{v}/Dialer/CallLog";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (phoneNumber === null || phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else
            content_.append("PhoneNumber", phoneNumber.toString());
        if (agentId === null || agentId === undefined)
            throw new Error("The parameter 'agentId' cannot be null.");
        else
            content_.append("AgentId", agentId.toString());
        if (sourceName === null || sourceName === undefined)
            throw new Error("The parameter 'sourceName' cannot be null.");
        else
            content_.append("SourceName", sourceName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallLog(_response);
        });
    }

    protected processCallLog(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface StateListItem {
    stateId?: number;
    stateName?: string | undefined;
    abbreviation?: string | undefined;
    selected?: boolean;
    isHeader?: boolean;
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface AgentInfoResponseModel {
    agentId?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    status?: number | undefined;
    statusText?: string | undefined;
    currentTime?: string | undefined;
    timeZone?: string | undefined;
    zip?: string | undefined;
    contactId?: number | undefined;
    hierarchies?: AgentSummaryHierarchy[] | undefined;
    marketers?: AgentSummaryMarketer[] | undefined;
    notes?: AgentNotesModel[] | undefined;
}

export interface AgentNotesModel {
    noteId?: number;
    userId?: number;
    name?: string | undefined;
    noOfDaysSinceNote?: number;
    dateCreated?: Date;
    comments?: string | undefined;
}

export interface AgentSummaryHierarchy {
    agentId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface AgentSummaryMarketer {
    marketerId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickname?: string | undefined;
    divisionId?: number;
    abbreviation?: string | undefined;
}

export interface CreateNoteAndTaskModel {
    agentId?: number;
    includeNotes?: boolean;
    includeTasks?: boolean;
    date?: Date | undefined;
    comments?: string | undefined;
}

export interface GenerateActiveCallListModel {
    marketer?: number | undefined;
    residentState?: ResidentState;
    licensedInStates?: string[] | undefined;
    leadSource?: number[] | undefined;
    licensedInCompany?: number[] | undefined;
    licensedNotInCompany?: number[] | undefined;
    licenseStatus?: number[] | undefined;
    agentInAHierachy?: number;
    agentDownline?: number | undefined;
    agentInThisDownLine?: boolean;
    lastSpokenDays?: number | undefined;
    haveNotSold?: boolean;
    soldProductStartingDate?: Date | undefined;
    soldProductEndingDate?: Date | undefined;
    soldProductTypes?: number[] | undefined;
    soldProductWithCompany?: number[] | undefined;
    callListName?: string | undefined;
    marketerEventId?: number | undefined;
    requireEmail?: boolean;
}

export interface ResidentState {
    states?: string[] | undefined;
    counties?: string[] | undefined;
    zipCodes?: string[] | undefined;
}

export interface GenerateProspectiveCallListModel {
    residentState?: ResidentState2;
    leadSource?: number[] | undefined;
    callListName?: string | undefined;
    marketerEventId?: number | undefined;
}

export interface ResidentState2 {
    states?: string[] | undefined;
    counties?: string[] | undefined;
    zipCodes?: string[] | undefined;
}

export interface CreateCustomCallListReponseModel {
    id?: number;
    message?: string | undefined;
}

export interface MarkAgentAsCalledModel {
    callListId?: number;
    agentId?: number;
}

export interface UpdateBadPhoneNumberModel {
    agentId?: number;
    contactId?: number;
}

export interface UpdateBadPhoneNumberNewContactInfo {
    contactId?: number;
    phoneNumber?: string | undefined;
}

export interface UpdateBadPhoneNumberResponse {
    message?: string | undefined;
    newContactInfo?: UpdateBadPhoneNumberNewContactInfo;
}

export interface ContactListRequestModel {
    marketer?: number;
    residentState?: ResidentState3;
    licensedInStates?: string[] | undefined;
    leadSource?: number[] | undefined;
    licensedInCompany?: number[] | undefined;
    licensedNotInCompany?: number[] | undefined;
    licenseStatus?: number[] | undefined;
    agentInAHierachy?: number;
    agentDownline?: number | undefined;
    agentInThisDownLine?: boolean;
    lastSpokenDays?: number | undefined;
    haveNotSold?: boolean;
    soldProductStartingDate?: Date | undefined;
    soldProductEndingDate?: Date | undefined;
    soldProductTypes?: number[] | undefined;
    soldProductWithCompany?: number[] | undefined;
    requireEmail?: boolean;
}

export interface ResidentState3 {
    states?: string[] | undefined;
    counties?: string[] | undefined;
    zipCodes?: string[] | undefined;
}

export interface GetActivePreviewRequestModel {
    pageIndex?: number;
    pageSize?: number;
    readonly skip?: number;
    readonly take?: number;
    sortColumn?: string | undefined;
    sortAscending?: boolean;
    fullTextFilter?: string | undefined;
    marketer?: number | undefined;
    residentState?: ResidentState4;
    licensedInStates?: string[] | undefined;
    leadSource?: number[] | undefined;
    licensedInCompany?: number[] | undefined;
    licensedNotInCompany?: number[] | undefined;
    licenseStatus?: number[] | undefined;
    agentInAHierachy?: number;
    agentDownline?: number | undefined;
    agentInThisDownLine?: boolean;
    lastSpokenDays?: number | undefined;
    haveNotSold?: boolean;
    soldProductStartingDate?: Date | undefined;
    soldProductEndingDate?: Date | undefined;
    soldProductTypes?: number[] | undefined;
    soldProductWithCompany?: number[] | undefined;
    requireEmail?: boolean;
}

export interface GetActivePreviewResponse {
    recordCount?: number;
    data?: GetActivePreviewResultsModel[] | undefined;
}

export interface GetActivePreviewResultsModel {
    agentId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    state?: string | undefined;
}

export interface ResidentState4 {
    states?: string[] | undefined;
    counties?: string[] | undefined;
    zipCodes?: string[] | undefined;
}

export interface GetAllStatesAndCountysResponse {
    states?: StateListItem[] | undefined;
    countiesByState?: { [key: string]: string[]; } | undefined;
}

export interface CompanyAndProductSubCategoryResponse {
    companies?: ListItem[] | undefined;
    subCategories?: ListItem[] | undefined;
}

export interface ExistingCallListResponse {
    recordCount?: number;
    data?: ExistingCallListResponseModel[] | undefined;
}

export interface ExistingCallListResponseModel {
    callListId?: number;
    callListName?: string | undefined;
    createdDate?: Date;
    called?: number;
    remaning?: number;
    startingTotal?: number;
}

export interface GetProspectivePreviewRequestModel {
    pageIndex?: number;
    pageSize?: number;
    readonly skip?: number;
    readonly take?: number;
    sortColumn?: string | undefined;
    sortAscending?: boolean;
    fullTextFilter?: string | undefined;
    residentState?: ResidentState5;
    leadSource?: number[] | undefined;
}

export interface GetProspectivePreviewResponse {
    recordCount?: number;
    data?: GetProspectivePreviewResultsModel[] | undefined;
}

export interface GetProspectivePreviewResultsModel {
    agentId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    state?: string | undefined;
}

export interface ResidentState5 {
    states?: string[] | undefined;
    counties?: string[] | undefined;
    zipCodes?: string[] | undefined;
}

export interface GetRecentCalledAgentsResponse {
    recordCount?: number;
    data?: GetRecentCalledAgentsResponseModel[] | undefined;
}

export interface GetRecentCalledAgentsResponseModel {
    callListId?: number;
    agentId?: number;
    agentName?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}